import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function SectionWiseReport({ section }) {
    const StudentPercentage = section?.StudentPercentage || 0;
    const Top1Percentage = section?.Top1Percentage || 0;

    const isLower = StudentPercentage < Top1Percentage;

    const data = {
        labels: ["Your performance", "Top 1% Student's performance"],
        datasets: [
            {
                data: [StudentPercentage, Top1Percentage],
                backgroundColor: isLower
                    ? ["#bc2929ff", "#00E396"]
                    : ["#00E396", "#bc2929ff"],
                borderWidth: 1,
            },
        ],
    };


    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "bottom",
                labels: { font: { size: 10 }, color: "#000" },
            },

            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const index = tooltipItem.dataIndex;
                        if (index === 2) return "";
                        return `${data.labels[index]}: ${data.datasets[0].data[index]}%`;
                    },
                },
            },
        },
    };

    return (
        <div
            className="card shadow-sm border-0 p-3 d-flex align-items-center"
            style={{
                minWidth: 220,
                maxWidth: 260,
                borderRadius: "15px",
                background: "#f9f9f9",
            }}
        >
            <h6 className="fw-semibold text-dark mb-3">
                {section?.SegmentName || "Segment Name"}
            </h6>

            <Pie data={data} options={options} width={280} />

            <div className="mt-3">
                <span className={`badge ${isLower ? "bg-danger" : "bg-success"} me-2`}>
                    Student: {StudentPercentage}%
                </span>
                <span className={`badge ${isLower ? "bg-success" : "bg-danger"}`}>
                    Top 1%: {Top1Percentage}%
                </span>
            </div>
        </div>
    );
}
